import React, { Component } from 'react'
import { Authenticated, GET_LIST, GET_ONE, CardActions, Button } from 'react-admin'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import CertificationIcon from '@material-ui/icons/CheckCircle';
import { withStyles } from '@material-ui/core/styles';

import DatoTecnicoFilters from './DatoTecnicoFilters'
import dataProvider from '../../utils/dataProvider'
import DatoTecnicoListTable from './DatoTecnicoListTable'

import { Link } from 'react-router-dom'
import AddIcon from '@material-ui/icons/Add'

import { schemaAsFieldArray } from '../../utils/schemas'

const styles = theme => ({
    title : {
      marginBottom: '20px',
      display: 'inline-flex',
      verticalAlign: 'middle',
      alignItems: 'center',
      fontSize: 23,
      '& svg' : { color: '#019EAC', paddingRight : 10 }
    },
    root: {
      overflow: 'visible'
    },
    snackbarWarning: {
      backgroundColor: theme.palette.error.light,
    },
    cardActions : {
        flex : 1
    }
})


class DatoTecnicoList extends Component {

    constructor(props) {
        super(props)

        this.state = {
            search: "",

            loading: false,

            tipoDatotecnico : null,
            schemaFields : [],
            datosTecnicos: [],

            sortColumn: "name",
            sortDirection: "ASC",

            totalResults: 0,
            currentPage: 1,
            perPage: 10,
        }

        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePerPageChange = this.handlePerPageChange.bind(this);
    }

    handleFilterChange = () => (event, value, old_value, name) => {
        if (name === "tipoDatoTecnico") {
            dataProvider(GET_ONE, "esquemas-datos-tecnicos", {id : value})
            .then(response => {
                let schemaFields = schemaAsFieldArray(_.get(response.data, 'schema'), {})
                this.setState({
                    currentPage: 1,
                    tipoDatotecnico: value,
                    schemaFields : schemaFields
                }, () => this.fetchResults())

            })
            .catch(error => {
                console.log(error)
            })
        }
    }

    handlePageChange(newPage) {
        this.setState({ currentPage: newPage }, () => this.fetchResults())
    }

    handlePerPageChange(newPerPage) {
        this.setState({
            currentPage: 1,
            perPage: newPerPage,
        }, () => this.fetchResults())
    }

    fetchResults() {
        const {
            search,
            tipoDatotecnico,
        } = this.state

        if (!tipoDatotecnico) return

        const filter = {
            datasheet_type : tipoDatotecnico
        };
        if (!!search) { filter["search"] = search }
        const params = {
            pagination: {
                page: this.state.currentPage,
                perPage: this.state.perPage,
            },
            sort: {
                field: this.state.sortColumn,
                order: this.state.sortDirection
            },
            filter
        }

        this.setState({ loading: true })

        dataProvider(GET_LIST, "datos-tecnicos", params)
            .then(response => {
                this.setState({
                    loading: false,
                    datosTecnicos : response.data,
                    totalResults: response.total,
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    render() {
        const { tipoDatotecnico, datosTecnicos } = this.state
        const { classes } = this.props

        return (
          <Authenticated
            authParams={{ required: true, roles: ["admin", "coordinador"] }}
            location={this.props.location}
          >
            <Card className={classes.root}>
              <CardContent>
                <Typography className={classes.title}>
                  <CertificationIcon /> Datos Técnicos
                </Typography>
                <Grid container spacing={16}>
                    <Grid item xs={12}>
                        <DatoTecnicoFilters
                            onChange={this.handleFilterChange}
                        //   onSearchChange={this.handleSearchChange}
                            onSubmit={this.handleFilterSubmit}
                        />
                    </Grid>
                    {tipoDatotecnico &&
                    <CardActions className={classes.cardActions}>
                        <Button 
                            label={"Agregar Dato Técnico"}
                            component={Link} 
                            to={{
                                pathname: '/datos-tecnicos/create',
                                state: { record: { datasheet_type : tipoDatotecnico, active : true } },
                            }}
                        >
                            <AddIcon/>
                        </Button>
                    </CardActions>}
                    <Grid item xs={12}>
                        {!tipoDatotecnico && <p>Escoja un tipo de dato técnico</p>}
                        {tipoDatotecnico &&
                        <DatoTecnicoListTable
                            total={this.state.totalResults}
                            datosTecnicos={datosTecnicos}
                            schemaFields={this.state.schemaFields}
                            page={this.state.currentPage}
                            perPage={this.state.perPage}
                            isLoading={this.state.loading}
                            onPageChange={this.handlePageChange}
                            onPerPageChange={this.handlePerPageChange}
                            {...this.props}
                        />}
                    </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Authenticated>
        )
    }
}

export default withRouter(withStyles(styles)(DatoTecnicoList))
